import { Box, styled } from '@mui/material';

export const ButtonContainer = styled(Box)`
  padding: 10px 21px;
`;
